var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueuingArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.584,
    height: 22.414,
    viewBox: "0 0 22.584 22.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4484",
    "data-name": "Group 4484",
    transform: "translate(6019.025 8632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4482",
    "data-name": "Group 4482",
    transform: "translate(-6019.02 -8632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_22_1_",
    d: "M15.84,0a3.992,3.992,0,0,0-2.79,1.13A3.757,3.757,0,0,0,11.9,3.85a3.941,3.941,0,0,0,7.88,0A3.9,3.9,0,0,0,15.84,0ZM8.15,5.21a2.607,2.607,0,0,0-2.53,2.6,2.635,2.635,0,0,0,2.67,2.6,2.6,2.6,0,0,0-.14-5.2ZM2.88,8.39A1.75,1.75,0,1,0,4.67,10.1,1.75,1.75,0,0,0,2.88,8.39Zm12.82.33a6.183,6.183,0,0,0-6.04,6.05V16h6.78a2,2,0,0,1,3.14-2.41L21.99,16h.03V14.77A6.188,6.188,0,0,0,15.7,8.72Zm-7.41,2.7a4.223,4.223,0,0,0-4.26,4.16V16H8.68V14.77a6.807,6.807,0,0,1,.81-3.16A4.423,4.423,0,0,0,8.29,11.42ZM2.96,12.88A2.919,2.919,0,0,0,.02,15.76V16H3.06v-.42a4.9,4.9,0,0,1,.73-2.57A3.341,3.341,0,0,0,2.96,12.88Z",
    fill: "#63666f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4477_1_",
    transform: "translate(25.145 -3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7472",
    "data-name": "Path 7472",
    d: "M-3.98,21.5H-24.15",
    fill: "none",
    stroke: "#63666f",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7473",
    "data-name": "Path 7473",
    d: "M-3.98,21.5l-1.41,1.41-1.6,1.59",
    fill: "none",
    stroke: "#63666f",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7474",
    "data-name": "Path 7474",
    d: "M-6.99,18.5l1,1,2.01,2",
    fill: "none",
    stroke: "#63666f",
    strokeLinecap: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueuingArea);
export default __webpack_public_path__ + "static/media/queuingArea.7b74b8996dd7f38b4c197e228d0a72a3.svg";
export { ForwardRef as ReactComponent };